import { render } from "./BaseLayoutLetsBeFriendsAndLookBook.vue?vue&type=template&id=8e513da0&ts=true"
import script from "./BaseLayoutLetsBeFriendsAndLookBook.vue?vue&type=script&lang=ts"
export * from "./BaseLayoutLetsBeFriendsAndLookBook.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__